// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestTags-cls1_6Hk","cls2":"ResearchInterestTags-cls2_ugC ResearchInterestTags-cls1_6Hk"};